import DropdownSelection from 'app/models/dropdown_selection';

export default DropdownSelection.extend({

  initialize(options) {
    this.dropdowns = options.dropdowns;
    this.dependentSelection = options.dependentSelection;
    this.paramKey = options.paramKey;
    this.setDefaultCurrentChoice();
    this.listenTo(this.dependentSelection, 'change', this.setDefaultCurrentChoice);
  },

  setDefaultCurrentChoice() {
    const dynamicKey = this.dependentSelection.get('currentChoice').option;
    const selection = this.dropdowns[dynamicKey];
    if (!selection) {
      throw new Error(['dropdowns must contain a property that correlates to the ',
        'dependentSelection\'s currentChoice.option'].join(''));
    }
    this.set('currentChoice', selection.choices[0], { silent: true });
  },
});



// WEBPACK FOOTER //
// ./app/models/dynamic_dropdown_selection.js